/**
 * What each phone recorder control does when tapped (spec 15.27), as a
 * table the handlers read, so both paths are unit tested:
 *
 * - Record/Save: idle, start a take; during a take, stop it and keep it
 *   (`'continue'`: the recorder stays open on the same segment, the
 *   playhead where it is, "Clip saved" once the take is kept).
 * - The trash (during a take only): ask "Discard this clip?".
 * - The alert's Discard: stop the take and drop it; the recorder stays open.
 * - The alert's Keep Recording: close the alert, the take runs on.
 */
export type RecorderControl = 'record-save' | 'trash' | 'alert-discard' | 'alert-keep';

export type RecorderTap =
  | { kind: 'start' }
  | { kind: 'stop'; mode: 'continue' }
  | { kind: 'ask'; alert: 'discard' }
  | { kind: 'abort' }
  | { kind: 'dismiss' }
  | { kind: 'none' };

export function recorderTap(control: RecorderControl, recording: boolean): RecorderTap {
  switch (control) {
    case 'record-save': return recording ? { kind: 'stop', mode: 'continue' } : { kind: 'start' };
    case 'trash': return recording ? { kind: 'ask', alert: 'discard' } : { kind: 'none' };
    case 'alert-discard': return recording ? { kind: 'abort' } : { kind: 'dismiss' };
    case 'alert-keep': return { kind: 'dismiss' };
  }
}

/**
 * Spec 15.27: the stop path waits for the recorder's `stop` event. iOS has
 * been seen to end a take without it, so after this long the take is
 * finalised from the chunks already received.
 */
export const STOP_WATCHDOG_MS = 2500;
